import React from "react";
import { createRoot } from "react-dom/client";
import App from "../packages/ui/src/App";
import "../packages/ui/src/styles.css";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App apiUrl={import.meta.env.VITE_ELYXIR_API_URL} />
  </React.StrictMode>,
);
